/**
 * IL CONTROLLO DELLA VERSIONE PUBBLICATA.
 *
 * Confronta la data di compilazione servita dal server (`/meta.json`) con quella scolpita
 * nel pacchetto (`package.json`): se il server ne ha una piu' recente, la scheda ha in mano
 * una versione vecchia e va ricaricata.
 *
 * ┌─ 🔴 PERCHE' IN SVILUPPO NON SI CONTROLLA NIENTE ─────────────────────────────────────┐
 * │                                                                                      │
 * │ `npm run build` scrive la data in DUE posti: `package.json` (che finisce dentro il    │
 * │ pacchetto) e `public/meta.json` (che il server serve). In produzione escono dalla     │
 * │ stessa compilazione e coincidono.                                                     │
 * │                                                                                      │
 * │ In sviluppo no: `/public/meta.json` e' in `.gitignore`, quindi resta quello dell'      │
 * │ ultima compilazione fatta su QUESTA macchina, mentre `package.json` e' quello del      │
 * │ repository — fermo al 2022, perche' la riscrittura fatta dal build non e' mai stata    │
 * │ committata. Il confronto dice sempre "sei vecchio", parte `window.location.reload()`,  │
 * │ e la pagina si ricarica all'infinito: `localhost:3000` non arriva mai a disegnare      │
 * │ niente. E' successo, e da fuori sembra un redirect impazzito.                          │
 * │                                                                                      │
 * │ In sviluppo il ricaricamento serve a zero: ci pensa gia' l'aggiornamento a caldo.      │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 */
export function checkVers() {
    const packageJson = require("../package.json");
    const moment = require("moment");

    return new Promise(function(resolve, reject) {
        if (process.env.NODE_ENV !== "production") {
            resolve();
            return;
        }

        const refreshCacheAndReload = () => {
            if (caches) {
                caches.keys().then((names) => {
                    for (const name of names) {
                        caches.delete(name);
                    }
                });
            }
            window.location.reload(true);
        };

        const buildDateGreaterThan = (latestDate, currentDate) => {
            const momLatestDateTime = moment(latestDate);
            const momCurrentDateTime = moment(currentDate);
            return momLatestDateTime.isAfter(momCurrentDateTime);
        };
        fetch("/meta.json")
            .then((response) => response.json())
            .then((meta) => {
                const latestVersionDate = meta.buildDate;
                const currentVersionDate = packageJson.buildDate;

                const shouldForceRefresh = buildDateGreaterThan(
                    latestVersionDate,
                    currentVersionDate
                );
                if (shouldForceRefresh) {
                    refreshCacheAndReload();
                } else {
                    resolve();
                }
            }).catch((err) => {
                resolve();
                console.log(err)
        });
    });
}
